import ChartsSection from "./ChartsSection";
import StaticSummary from "./StaticSummary";

const SummarySection = (props) => {
//heights as %
  const staticSection = 0
  const graphicsSection = props.height - staticSection;

  return (
    <div
      id="summary"
      style={{ height: "100%", width: props.width, background: "#cbcaca" }}
    >
              {/* <div
        style={{height:staticSection,padding:15,textAlign:"center",background:"#f9f9f9",boxSizing:"border-box",margin:0}}
        ><h3>Summary Charts</h3></div> */}
        {/* <StaticSummary 
        height={staticSection}
        width={props.width}
        /> */}
        <ChartsSection 
        focusCountry={props.focusCountry}
        height={graphicsSection}
        />

    </div>
  );
};

export default SummarySection;
